<template>
  <section>
            <div class="row top-margin">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">First name <strong class="text-info">*</strong></label>
                  <input type="text" name="FirstName" id="FirstName" v-model="firstName" placeholder="First name" :class="{ 'form-control': true, 'form-control-error': errors.has('FirstName') }" v-validate="{required: true}" />
                  <span v-if="errors.has('FirstName')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Last name <strong class="text-info">*</strong></label>
                  <input type="text" name="LastName" id="LastName" v-model="lastName" placeholder="Last name" :class="{ 'form-control': true, 'form-control-error': errors.has('LastName') }" v-validate="{required: true}" />
                  <span v-if="errors.has('LastName')" class="error-feedback">Required</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Company name 1 <strong class="text-info">*</strong></label>
                  <input type="text" name="CompanyName1"
                    id="CompanyName1"
                    v-model="financialAccount.organizationName"
                    placeholder="Company name"
                    :class="{ 'form-control': true, 'form-control-error': errors.has('CompanyName1') }" v-validate="{required: true}" />

                  <span v-if="errors.has('CompanyName1')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Company name 2</label>
                  <input type="text" name="CompanyName2"
                    id="CompanyName2" v-model="financialAccount.alternateCompanyName" placeholder="Company name" :class="{ 'form-control': true, 'form-control-error': errors.has('CompanyName2') }" />
                </div>
              </div>
            </div>

            <div class="row">
               <div class="col-md-6" >
                <div class="form-group">
                  <label for="address">Email <strong class="text-info">*</strong></label>
                  <input type="text" name="Email" id="Email" v-model="email" placeholder="Email" :class="{ 'form-control': true, 'form-control-error': errors.has('Email') }" v-validate="{required: true}" @input="emailUpdated"/>
                  <span v-if="errors.has('Email')" class="error-feedback">Required</span>
                </div>
              </div>
              <div class="col-md-6" >
                <div class="form-group">
                  <label for="address">CRD number</label>
                  <input type="text" name="CRD" id="CRD" placeholder="CRD NUMBER"
                  v-model="financialAccount.CRDnumber" :class="{ 'form-control': true, 'form-control-error': errors.has('CRD') }" />
                  <span v-if="errors.has('CRD')" class="error-feedback">Required</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="primaryPhoneNum">Primary phone number <strong class="text-info">*</strong></label>
                  <input id="primaryPhoneNum" name="primaryPhoneNum" v-model="primaryPhoneNum" placeholder="Phone number" :class="{ 'form-control': true,
                  'form-control-error': errors.has('primaryPhoneNum') }" v-validate="{ required: true }"
                  v-mask="'(999) 999-9999'"
                  />
                  <span v-if="!isValidPrimaryPhoneNumber()" class="error-feedback">Required</span>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="secondaryPhoneNum">Secondary phone number</label>
                  <input id="secondaryPhoneNum" v-model="secondaryPhoneNum" name="secondaryPhoneNum" class="form-control" type="text"  :class="{ 'form-control': true, 'form-control-error': errors.has('secondaryPhoneNum') }" v-validate="{ regex:/^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/ }" v-mask="'(999) 999-9999'" />
                   <span v-if="errors.has('secondaryPhoneNum')" class="error-feedback">Wrong phone number</span>
                </div>
              </div>
            </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import { formatDate } from '@/util';

  const mix = {
    methods: {
      formatDate,
    },
  };

  export default {
    name: 'BasicFinancialInformation',
    mixins: [mix],
    props: ['basicFinancialInformation'],
    data() {
      return {
        minimumAge: 18,
        email: '',
        firstName: '',
        lastName: '',
        primaryPhoneNum: '',
        secondaryPhoneNum: '',
        financialAccount: {},
      };
    },
    async beforeMount() {
      this.email = this.basicFinancialInformation.email;
      this.firstName = this.basicFinancialInformation.firstName;
      this.lastName = this.basicFinancialInformation.lastName;
      this.primaryPhoneNum = this.getPhoneDigits(this.basicFinancialInformation.primaryPhoneNum);
      this.secondaryPhoneNum = this.getPhoneDigits(this.basicFinancialInformation.secondaryPhoneNum);
      this.financialAccount = this.basicFinancialInformation.accounts
        .find(account => account.accountType === this.accountTypes.ADVISOR.name);
    },
    mounted() {
      this.emailUpdated();
    },
    computed: {
      ...mapState('app', [
        'accountTypes',
      ]),
    },
    watch: {
      email() {
        this.formHasChanged();
      },
      firstName() {
        this.formHasChanged();
      },
      lastName() {
        this.formHasChanged();
      },
      primaryPhoneNum() {
        this.formHasChanged();
      },
      secondaryPhoneNum() {
        this.formHasChanged();
      },
      financialAccount: {
        handler() {
          this.formHasChanged();
        },
        deep: true,
      },
    },
    methods: {
      validate() {
        const primaryEmailValid = this.validEmail(this.email);
        return primaryEmailValid &&
               this.firstName.trim() !== '' &&
               this.lastName.trim() !== '' &&
               this.primaryPhoneNum.trim() !== '' &&
               this.financialAccount.organizationName.trim() !== '' &&
               this.isValidPrimaryPhoneNumber();
      },
      formHasChanged() {
        this.$emit('validated', this.validate());
      },
      emailUpdated() {
        const valid = this.validEmail(this.email);
        this.$emit('emailUpdated', { valid });
      },
      validEmail(email) {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
        return regex.test(email);
      },
      isValidPrimaryPhoneNumber() {
        const regex = /^[0-9]{10}$/; // eslint-disable-line no-useless-escape
        return regex.test(this.getPhoneDigits(this.primaryPhoneNum));
      },
      getPhoneDigits(phoneNum) {
        return phoneNum ? phoneNum.replace(/[-() ]/g, '') : '';
      },
      getData() {
        return {
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
          alternateCompanyName: this.financialAccount.alternateCompanyName,
          organizationName: this.financialAccount.organizationName,
          CRDnumber: this.financialAccount.CRDnumber,
          primaryPhoneNum: this.getPhoneDigits(this.primaryPhoneNum),
          secondaryPhoneNum: this.getPhoneDigits(this.secondaryPhoneNum),
        };
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .message-feedback {
    background-color: #dbe9db;
    margin-left: 2%;
    margin-top: 2%;
    margin-bottom: 2%;
    width: 66%;
  }

  .birth-field-bottom {
    margin-bottom: 5px;
  }

  .button-submit {
    background-color: #127285;
  }

  .date-pick-style {
    width: 90%;
  }

  .content-wrapper {
    border-top: none;
  }

  .warning-heading {
    background-color: #f9f2ce !important;
    padding: 10px;
    margin: 0 auto 20px;
    font-size: 14px;
    font-weight: 500;
  }

  .alert-warning {
    background-color: #fcf8e3;
    border-color: #faf2cc;
    color: #8a6d3b;
    margin: 25px;
    margin-bottom: 10px;
  }

  .btn-back {
    color: #31b0d5;
    background-color: Transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    padding-left: 20px;
  }

  .icon-back {
    position: relative;
  }

  .icon-back:before {
    content: "\f060";
    font-family: FontAwesome;
    position: absolute;
    left: 0px;
  }

  .alert-warning .alert-link {
    color: #66512c;
  }

  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }

  .left-margin {
    margin-left: 4%;
  }

  .right-margin {
    margin-right: 4%;
  }

  .top-margin {
    margin-top: 2%;
  }

  .bottom-margin {
    margin-bottom: 2%;
  }

  .space {
    margin-top: 4%;
  }

  .content-heading {
    font-weight: normal;
  }

  .upload-container {
    height: 80px;
    padding-top: 10px;
  }

  .panel-title {
    font-size: 20px;
  }

  .panel-subtitle {
    font-size: 16px;
  }

  .panel-default {
    padding: 30px 40px;
    width: 900px;
  }

  .panel-heading {
    background-color: #ffffff;
    font-size: 16px;
    padding: 0px 5px;
  }

  label {
    color: #888;
    font-size: 14px;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
  }

  select:required:invalid {
    color: lightgray;
  }

  option[value=""][disabled] {
    display: none;
  }

  option {
    color: black;
  }

   ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: lightgray;
    opacity: 1;
    /* Firefox */
  }

   :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: lightgray;
  }

   ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: lightgray;
  }

  .disabled-state {
    color: #ccc;
  }

  .text-red {
    color: #a94442;
  }

  .btn-new {
    background-color: #127285;
  }

  .radio-item {
    display: inline-block;
    position: relative;
    padding: 0 6px;
  }

  .radio-item input[type='radio'] {
    display: none;
  }

  .radio-item label {
    color: #666;
    font-weight: normal;
  }

  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: relative;
    top: 5px;
    left: 0px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }

  .radio-item-repay label:before {
    left: 190px;
  }

  .radio-item-unselected label:before {
    border: 2px solid #d3d3d3;
  }

  .radio-item input[type=radio]:checked+label:after {
    border-radius: 11px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    left: 11px;
    content: " ";
    display: block;
  }

  .radio-item-repay input[type=radio]:checked+label:after {
    left: 201px;
  }
  .table {
    width: 1400px;
  }

  .table > thead > tr > th {
    vertical-align: bottom;
    border-bottom: 0px #ddd;
  }
  tbody{
    height:200px;
      overflow-y:auto;
      width: 100%;
  }
  thead{
    display:block;
    width: 100%;
  }
  tbody{
    display:block;
  }
  tr{
    width: 100%;
    display: block;
  }
  td{
    display:block;
    width: 14%;
  }
  th{
    display:block;
    width: 14%;
  }
  td{
    float: left;
    width: 14%;
  }
  thead{
    float: left;
  }
  tr{
    float: left;
  }
  th{
    float: left;
  }
  .smallWidth{
    width: 10%
  }
  .bigWidth{
    width: 16%
  }
</style>



// WEBPACK FOOTER //
// BasicFinancialInformation.vue?30971390